import FileUploadedItemV2 from 'components/molecules/FileUploadedList/FileUploadedItemV2.component';
import type { FC } from 'react';
import { useAIChatContext } from './AIChat.context';

const AIChatAttachements: FC = () => {
  const { attachmentApi } = useAIChatContext();
  const { attachments, upload, remove } = attachmentApi;

  if (!attachments.length) return null;

  return (
    <div className="w-full flex flex-row gap-1 my-1">
      {attachments.map((attachment, index) => (
        <FileUploadedItemV2
          key={index}
          name={attachment.file.name}
          size={attachment.file.size}
          status={attachment.status}
          progress={attachment.progress || 0}
          onRetry={() => upload(attachment.file)}
          onRemove={() => remove(index)}
        />
      ))}
    </div>
  );
};
export default AIChatAttachements;
